"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const Order = {
    fragments: {
        tickets: {},
        upgrades: {},
        promotions: {},
    },
};
exports.default = Order;
Order.fragments = {
    tickets: (0, client_1.gql) `
    fragment OrderTickets on Order {
      tickets {
        _id
        name
        ticketTypeId
        ticketTierId
        price
        origionalPrice
        values
        seat
        isTicketSharing
        dayIds
        qrCodeUrl
        paymentId
        state
        refund {
          refunded
          refundedAt
          refundedBy
          refundReason
          refundedAmount
        }
        scan {
          scanned
          scannedAt
          scannedBy
          startsAt
          endsAt
          scannerName
        }
        parentTicketId
      }
    }
  `,
    upgrades: (0, client_1.gql) `
    fragment OrderUpgrades on Order {
      upgrades {
        _id
        name
        upgradeId
        price
        qrCodeUrl
        paymentId
        state
        isAddOnsSharing
        refund {
          refunded
          refundedAt
          refundedBy
          refundReason
          refundedAmount
        }
        scan {
          scanned
          scannedAt
          scannedBy
          startsAt
          scannerName
        }
        parentUpgradeId
      }
    }
  `,
    promotions: (0, client_1.gql) `
    fragment EventPromotions on Event {
      promotions {
        _id
        code
        type
        totalQty
        remainingQty
        ticketTypeIds
        upgradeIds
        active
        startsAt
        endsAt
        useLimit
        overRideMax
        overRideMaxUpg
        discountType
        discountValue
        appliesTo
      }
    }
  `,
};
//# sourceMappingURL=order.fragment.js.map